import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BullhornEntityFieldMetaService } from '../entity-field-meta/bullhorn.entity-field-meta.service';
import { IEntityLabelPair } from '../entity-type/entity-type.service';
import { IAttachmentSourceOptionLabelService, ISourceOption } from './iattachment-source-option-label.service';

@Injectable({ providedIn: 'root' })
export class BullhornAttachmentSourceOptionLabelService implements IAttachmentSourceOptionLabelService {
  constructor(private bullhornEntityFieldMetaService: BullhornEntityFieldMetaService) {}

  getOptions(optionPaths: string[]): Observable<ISourceOption[]> {
    return this.bullhornEntityFieldMetaService.entityMeta$.pipe(
      map((entities) => this.getLabelsForOptionPaths(optionPaths ?? [], entities)),
    );
  }

  private getLabelsForOptionPaths(optionPaths: string[], entities: IEntityLabelPair[]): ISourceOption[] {
    return optionPaths.map((optionPath) => {
      const label = this.bullhornEntityFieldMetaService.getMetaLabelFromPath(entities, optionPath);
      return {
        label: label ?? optionPath,
        toolTip: optionPath,
        path: optionPath,
      };
    });
  }
}
